import classnames from "classnames";
import { humanize } from "neetocist";
import { Tooltip, Typography } from "neetoui";

const Icon = ({ active, icon, onClick, symbolsStyle, style }) => (
  <Tooltip content={humanize(icon)} position="bottom" touch={["hold", 500]}>
    <div
      {...{ style }}
      data-testid={`icon-picker-icon-${icon}`}
      className={classnames(
        "neeto-ui-rounded-md flex cursor-pointer items-center justify-center",
        {
          "neeto-ui-text-gray-700 hover:neeto-ui-bg-gray-100": !active,
          "neeto-ui-text-white neeto-ui-bg-primary-500": active,
        }
      )}
      onClick={() => onClick(icon)}
    >
      <div
        className="flex w-11/12 flex-col justify-center p-1"
        style={symbolsStyle}
      >
        <span className="material-symbols-rounded mx-auto">{icon}</span>
        <Typography className="line-clamp-2 text-center" style="body3">
          {humanize(icon)}
        </Typography>
      </div>
    </div>
  </Tooltip>
);

export default Icon;
